// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags-tags-3h2OZ"};